export default "__VITE_ASSET__asy1Kvx1__"